// extracted by mini-css-extract-plugin
export default {"icon":"icon__gO2EA","_9list":"_9list__dwsm3","_mykeyboard":"_mykeyboard__vNUx4","shadow":"shadow__VOslZ"};